const EMAIL_PATTERN = new RegExp('^[^\s@]+@[^\s@]+\.[^\s@]+$');

function showFieldError(group: HTMLElement, show: boolean): void {
  group.classList.toggle('events-detail__form-group--invalid', show);
}

function clearFormErrors(form: HTMLFormElement): void {
  form.querySelectorAll<HTMLElement>('.events-detail__form-group--invalid').forEach((group) => {
    group.classList.remove('events-detail__form-group--invalid');
  });

  const globalError = form.querySelector<HTMLElement>('.events-detail__form-error--global');
  if (globalError) {
    globalError.hidden = true;
    globalError.textContent = '';
  }
}

function setGlobalError(form: HTMLFormElement, message: string, show: boolean): void {
  const globalError = form.querySelector<HTMLElement>('.events-detail__form-error--global');
  if (!globalError) {
    return;
  }

  globalError.textContent = message;
  globalError.hidden = !show;
}

function setFormStatus(form: HTMLFormElement, message: string): void {
  const status = form.querySelector<HTMLElement>('.events-detail__form-status');
  if (!status) {
    return;
  }

  status.textContent = message;
  status.hidden = !message;
}

function validateForm(form: HTMLFormElement): boolean {
  clearFormErrors(form);
  let isValid = true;

  const firstName = form.querySelector<HTMLInputElement>('[name="pardot_form_firstname"]');
  const lastName = form.querySelector<HTMLInputElement>('[name="pardot_form_lastname"]');
  const email = form.querySelector<HTMLInputElement>('[name="pardot_form_email"]');
  const company = form.querySelector<HTMLInputElement>('[name="pardot_form_company"]');

  if (!firstName?.value.trim()) {
    showFieldError(firstName?.closest('.form-group') as HTMLElement, true);
    isValid = false;
  }

  if (!lastName?.value.trim()) {
    showFieldError(lastName?.closest('.form-group') as HTMLElement, true);
    isValid = false;
  }

  if (!email?.value.trim() || !EMAIL_PATTERN.test(email.value.trim() as string)) {
    showFieldError(email?.closest('.form-group') as HTMLElement, true);
    isValid = false;
  }

  if (!company?.value.trim()) {
    showFieldError(company?.closest('.form-group') as HTMLElement, true);
    isValid = false;
  }

  return isValid;
}

function getUTMParam(name: string): string {
  const fromSessionStorage = JSON.parse(sessionStorage.getItem('utmParams') || '{}')[name] || '';
  const fromURL = new URLSearchParams(window.location.search).get(name) || '';

  return fromSessionStorage || fromURL;
}

function populateUTMFields(form: HTMLFormElement): void {
  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

  // Process each UTM parameter
  utmParams.forEach(function (param) {
    const value = getUTMParam(param);
    if (value) {
      const fields = form.querySelectorAll(`input[name="${param}"], input[name="${param}2"]`);
      fields.forEach((field) => ((field as HTMLInputElement).value = value));
    }
  });
}

populateUTMFields(document.querySelector('.events-detail__register-form') as HTMLFormElement);

async function submitRegistrationForm(form: HTMLFormElement): Promise<void> {
  const handlerUrl = form.dataset.formHandler?.trim() ?? '';
  const submitButton = form.querySelector<HTMLButtonElement>('[type="submit"]');

  if (!handlerUrl) {
    setGlobalError(form, 'Registration is not configured for this event. Please use the contact details below.', true);
    return;
  }

  if (!validateForm(form)) {
    setGlobalError(form, 'Please correct the highlighted fields and try again.', true);
    return;
  }

  const getFormData = () => {
    const params = {
      //object keys have to be all lowercase because of pardot
      pardot_form_email: (document.querySelector("[name='pardot_form_email']") as HTMLInputElement)?.value as string,
      pardot_form_firstname: (document.querySelector("[name='pardot_form_firstname']") as HTMLInputElement)
        ?.value as string,
      pardot_form_lastname: (document.querySelector("[name='pardot_form_lastname']") as HTMLInputElement)
        ?.value as string,
      pardot_form_company: (document.querySelector("[name='pardot_form_company']") as HTMLInputElement)
        ?.value as string,
    };

    const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

    // Add UTM parameters to params object if they exist
    utmParams.forEach(function (param) {
      const value =
        getUTMParam(param) || (document.querySelector(`[name='${param}']`) as HTMLInputElement)?.value;
      (params as Record<string, string>)[param] = value;
      (params as Record<string, string>)[param + '2'] = value;
    });

    return params;
  };

  const formData = getFormData();
  console.log(formData);

  if (submitButton) {
    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');
  }

  await fetch(handlerUrl, {
    method: 'POST',
    mode: 'no-cors',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Access-Control-Allow-Origin': '*',
    },
    body: Object.keys(formData)
      .map((key) => key + '=' + formData[key as keyof typeof formData])
      .join('&'),
  })
    .then((response) => {
      if (!response.ok && response.status !== 0) {
        throw new Error('Failed to submit registration');
      } else {
        form.reset();
        setFormStatus(form, 'Thank you. Your registration has been submitted.');
        setGlobalError(form, '', false);
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
        }
      }
    })
    .catch((error) => {
      console.error('Error submitting registration', error);
      throw error;
    });
}

function initEventRegistrationForms(): void {
  document.querySelectorAll<HTMLFormElement>('.events-detail__register-form').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      void submitRegistrationForm(form);
    });

    form.querySelectorAll<HTMLInputElement>('input').forEach((input) => {
      input.addEventListener('input', () => {
        const group = input.closest('.form-group');
        if (group) {
          group.classList.remove('events-detail__form-group--invalid');
        }
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEventRegistrationForms);
} else {
  initEventRegistrationForms();
}
